export default __webpack_public_path__ + "static/media/icon-bin-remove.385a436d.svg";